export default __webpack_public_path__ + "static/media/Why.6af6ff9c.gif";